module.exports = __webpack_public_path__ + "img/stage1.0f366a05.png";